import React, { useState } from 'react'
import {
  ArrowLeft,
  Check,
  CheckCircle,
  ExternalLink,
  Loader,
  Users,
} from 'lucide-react'
import { API_CONFIG } from '../../config/apiConfig'
import { formatCurrency } from '../../utils/formatters'
import './AuthFlow.scss'
import apiService from '../../services/apiService'
import authService from '../../services/authService'

const PlanSelection = ({
  registerData,
  onPlanSelected,
  onSuccessFreeRegister,
  renewSubscriptionData,
  goBack,
  onLoginSuccess,
}) => {
  const [selectedPlan, setSelectedPlan] = useState('standard')
  const [status, setStatus] = useState('')
  const [error, setError] = useState('')

  const plans = Object.values(API_CONFIG.PLANS)

  const getPlanFeatures = (planId) => {
    const features = [
      'Gestion complète des stocks produits',
      'Suivi des achats et clients',
    ]

    if (planId === 'standard' || planId === 'premium') {
      features.push('Génération de factures clients 🔥')
    }

    features.push('Tableaux de bord en temps réel')
    features.push('Espace gérant')
    features.push('Export et import de données')
    // features.push('Sauvegarde de données')

    if (planId === 'standard') {
      features.push('Support prioritaire 🔥')
    } else if (planId === 'premium') {
      features.push('Support prioritaire 🔥')
      features.push('Statistiques avancées 🔥')
      features.push('Rapports personnalisés 🔥')
    }

    features.push('Application Offline (fonctionne hors ligne)')

    return features
  }

  const handleContinue = () => {
    const plan = plans.find((p) => p.id === selectedPlan)
    onPlanSelected(plan)
  }

  const handleFreePlanSelect = async () => {
    setError('')

    const connected = await authService.isOnline()
    if (!connected) {
      setError('Votre connexion Internet semble interrompue.')
      return
    }

    setStatus('processing')

    try {
      const response = await apiService.registerFreeTrial('essai', registerData)

      if (response.success) {
        setTimeout(async () => {
          const token = authService.getToken()
          if (token) {
            await apiService.logout(token)
          }
          setStatus('success')
          if (response.data?.token) {
            onLoginSuccess(response.data)
          }
        }, 3000)
      } else {
        setStatus('')
        setError(response.error || "Erreur lors de l'inscription")
      }
    } catch (err) {
      setStatus('')
      setError('Erreur de connexion. Vérifiez votre connexion internet.')
    }
  }

  return (
    <div className='auth-container'>
      <div className='auth-header'>
        {renewSubscriptionData.renewSubscription && (
          <button
            onClick={() => goBack(renewSubscriptionData?.flowFrom)}
            className='btn-back'
          >
            <ArrowLeft size={20} />
          </button>
        )}
        <h1 className='auth-title'>
          OGC<span style={{ color: 'red' }}>2</span>
          <span style={{ color: 'rgb(255, 255, 42)' }}>2</span>
          <span style={{ color: '#00d700' }}>4</span>
        </h1>
      </div>

      {status && (
        <div className='auth-card'>
          {status === 'processing' && (
            <div className='payment-status processing'>
              <Loader size={48} className='spinning' />
              <h3>Inscription en cours...</h3>
              <p>Veuillez patienter, ne fermez pas cette fenêtre</p>
            </div>
          )}

          {status === 'success' && (
            <div className='payment-status success'>
              <CheckCircle size={64} className='success-icon' />
              <h3>Inscription réussie !</h3>
              <p>Votre compte a été créé avec succès.</p>

              <button
                onClick={() => onSuccessFreeRegister()}
                className='redirect-login-link'
              >
                <ExternalLink size={16} />
                Se connecter maintenant
              </button>
            </div>
          )}
        </div>
      )}

      {!status && (
        <div className='auth-card wide'>
          <h2 className='auth-card-title'>Choisissez votre plan</h2>
          <p className='auth-card-subtitle'>
            Sélectionnez le plan adapté à vos besoins
          </p>

          {!renewSubscriptionData.renewSubscription && (
            <div
              style={{
                width: '100%',
                marginBottom: '50px',
              }}
            >
              <div
                className={`plan-card`}
                style={{
                  width: '100%',
                  border: '2px solid #d97706',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  columnGap: '40px',
                  rowGap: '20px',
                  flexWrap: 'wrap',
                }}
              >
                <div>
                  <div className='plan-header' style={{ textAlign: 'left' }}>
                    <h3 className='plan-name'>Plan Découverte</h3>
                  </div>
                  <ul className='plan-features'>
                    <li key='1'>
                      <Check size={16} className='check-icon' />
                      Gestion complète des produits
                    </li>
                    <li key='2'>
                      <Check size={16} className='check-icon' />
                      Suivi des achats et commandes
                    </li>
                    <li key='3'>
                      <Check size={16} className='check-icon' />
                      Analytics détaillées CA/Ventes
                    </li>
                    <li key='4'>
                      <Check size={16} className='check-icon' />
                      Tableau de bord personnalisable
                    </li>
                  </ul>
                </div>

                <div
                  style={{
                    border: '1px solid #d8d8d8ff',
                    padding: '30px',
                    borderRadius: '20px',
                  }}
                >
                  <div style={{ color: '#d97706' }} className='plan-price'>
                    {formatCurrency(0)}
                  </div>
                  <div
                    style={{ textAlign: 'center' }}
                    className='plan-sessions'
                  >
                    <span>
                      Testez gratuitement OGC pendant 7 jours. <br />
                      (Sans engagement)
                    </span>
                  </div>
                  <div className='plan-select-indicator'>
                    <div
                      onClick={
                        () => handleFreePlanSelect()
                        // onPlanSelected({
                        //   id: 'essai',
                        //   name: 'Plan Découverte',
                        //   price: 0,
                        //   currency: 'GNF',
                        //   maxSessions: 1,
                        //   description: '1 utilisateur connecté simultanément',
                        // })
                      }
                      style={{ backgroundColor: '#d97706' }}
                      className='selected-badge'
                    >
                      Commencer avec le Plan Découverte
                    </div>
                  </div>
                  {error && (
                    <div style={{ marginTop: '20px' }} className='auth-error'>
                      {error}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          <div className='plans-grid'>
            {plans.map(
              (plan) =>
                plan.id !== 'essai' && (
                  <div
                    key={plan.id}
                    className={`plan-card ${selectedPlan === plan.id ? 'selected' : ''}`}
                    onClick={() => setSelectedPlan(plan.id)}
                  >
                    {plan.id === 'standard' && (
                      <div className='plan-badge'>Populaire</div>
                    )}

                    <div className='plan-header'>
                      <h3 className='plan-name'>{plan.name}</h3>
                      <div className='plan-price'>
                        {formatCurrency(plan.price)}
                        <span className='plan-period'>/mois</span>
                      </div>
                    </div>

                    <div className='plan-sessions'>
                      <Users size={20} />
                      <span>{plan.description}</span>
                    </div>

                    <ul className='plan-features'>
                      {getPlanFeatures(plan.id).map((feature, index) => (
                        <li key={index}>
                          <Check size={16} className='check-icon' />
                          {feature}
                        </li>
                      ))}
                    </ul>

                    {/* <div className='plan-select-indicator'>
                  {selectedPlan === plan.id && (
                    <div className='selected-badge'>
                      <Check size={16} /> Sélectionné
                    </div>
                  )}
                </div> */}

                    {selectedPlan === plan.id && (
                      <button
                        onClick={handleContinue}
                        className='btn primary lg full'
                      >
                        Continuer avec{' '}
                        {plans.find((p) => p.id === selectedPlan)?.name}
                      </button>
                    )}
                  </div>
                ),
            )}
          </div>

          <div className='plan-info'>
            <p>
              ✓ Annulation à tout moment
              <br />✓ Support client disponible 24/7
            </p>
          </div>
        </div>
      )}

      <div className='auth-footer'>
        Besoin d'aide ? Contactez-nous sur WhatsApp au{' '}
        <span
          onClick={() => {
            window.open('https://wa.me/224621994206', '_blank')
          }}
        >
          +224 621 99 42 06
        </span>
      </div>
    </div>
  )
}

export default PlanSelection
